module.exports = __webpack_public_path__ + "media/images/area/maps/okinawa-region-b121cfb1b423bff3d4221ae88266db5d.svg";